import {compose} from "redux"
import styled from "styled-components"

// Models
import {SignUpCredentialsInterface} from "../../../../models"

// Component
import SignUpForm from "./SignUpForm"

// HOCs
import withUtils, {WithUtilsProps} from "../../../../../../hoc/withUtils"

export type SignUpFormProps = {
    className?: string
    loading: boolean
    onSubmit: (credentials: SignUpCredentialsInterface) => void
} & WithUtilsProps

const StyledSignUpForm = styled(SignUpForm)`
    & .fields-row {
        display: flex;
        justify-content: space-between;
    
        & .ant-row {
            flex-basis: 48%;
        }
    }
`;

export default compose(
    withUtils,
)(StyledSignUpForm)
